import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { AuthV2GrpcContractService } from '../../api/grpc/services/auth-v2.service';
import { AuthStatusCookieService } from '../../services/auth-status-cookie.service';
import { TokenService } from '../../services/token.service';
import * as actions from '../actions/auth.actions';

/** Code length the backend issues — matches the 6-digit confirmation field. */
const LOGIN_CODE_LENGTH = 6;
@Injectable()
export class AuthEffects {
  /** Email step → AuthV2.Login sends a confirmation code to the address. */
  sendEmail$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SEND_EMAIL_COMMAND),
      switchMap(({ email }) =>
        this._authV2GrpcContractService
          .login({ PhoneNumberOrEmail: email, Language: 'en', CodeLength: LOGIN_CODE_LENGTH })
          .pipe(
            map(() => actions.SEND_EMAIL_SUCCESS()),
            catchError(() => of(actions.SEND_EMAIL_FAILURE())),
          ),
      ),
    ),
  );

  /**
   * Confirm step → AuthV2.ConfirmCodeLogin returns the auth Token; swap it into the cookie so the
   * session upgrades from anonymous to the logged-in user (same TokenService write as questionnaireResolver).
   */
  confirmCode$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.CONFIRM_CODE_COMMAND),
      switchMap(({ email, code }) =>
        this._authV2GrpcContractService
          .confirmCodeLogin({ PhoneNumberOrEmail: email, ConfirmCodeLoginV2WpcRequest: { ConfirmCode: code } })
          .pipe(
            tap((response) => {
              if (response?.Token) {
                this._tokenService.token = response.Token;
                this._authStatusCookieService.setSuccess();
              }
            }),
            map(() => actions.CONFIRM_CODE_SUCCESS()),
            catchError(() => of(actions.CONFIRM_CODE_FAILURE())),
          ),
      ),
    ),
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _authV2GrpcContractService: AuthV2GrpcContractService,
    private readonly _tokenService: TokenService,
    private readonly _authStatusCookieService: AuthStatusCookieService,
  ) {}
}
